import React, { useState, useEffect, useRef } from "react";
import "../styles/ProjectCard.css";

interface Project {
  title: string;
  description: string;
  mediaUrls: string[]; // Array of image and video URLs
  link?: string;
}

const ProjectCard: React.FC<{ project: Project }> = ({ project }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for fullscreen modal
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (project.mediaUrls[currentIndex].endsWith(".mp4")) {
      videoRef.current?.play();
    }
  }, [currentIndex, project.mediaUrls]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? project.mediaUrls.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === project.mediaUrls.length - 1 ? 0 : prevIndex + 1
    );
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="project-card">
      <div className="project-left">
        <div className="carousel">
          <div className="carousel-media-container" onClick={toggleModal}>
            {project.mediaUrls[currentIndex].endsWith(".mp4") ? (
              <video
                ref={videoRef}
                src={project.mediaUrls[currentIndex]}
                className="carousel-media"
                autoPlay
                muted
                loop
                controls={true}
              />
            ) : (
              <img
                src={project.mediaUrls[currentIndex]}
                alt={`${project.title} ${currentIndex + 1}`}
                className="carousel-media"
              />
            )}
          </div>
          <button className="carousel-button prev" onClick={handlePrev}>
            &lt;
          </button>
          <button className="carousel-button next" onClick={handleNext}>
            &gt;
          </button>
          <div className="carousel-dots">
            {project.mediaUrls.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="project-right">
        <h3>{project.title}</h3>
        <p>{project.description}</p>
        {project.link && (
          <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-button"
          >
            View Project
          </a>
        )}
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content">
            {project.mediaUrls[currentIndex].endsWith(".mp4") ? (
              <video
                src={project.mediaUrls[currentIndex]}
                className="modal-media"
                autoPlay
                muted
                loop
                controls={true}
              />
            ) : (
              <img
                src={project.mediaUrls[currentIndex]}
                alt={`${project.title} ${currentIndex + 1}`}
                className="modal-media"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectCard;
